import React from "react";
import PropTypes from "prop-types";
import { Alert, Row, Col } from "react-bootstrap";
import lstrings from "../../../../utils/LStrings";
import moment from "moment";
import { merge } from "lodash";
import UI from "../../../../utils/UiUtils";
import ApiClient from "../../../../utils/ApiClient";
import { INFO_KEY, VARIABLES_PERSONAS, FF_PRINT_PDF } from "../../../../config";
import HeaderDetalle from "../../../../components/header-detalle/HeaderDetalle";
import PanelDatosParticulares from "./components/PanelDatosParticulares";
import PanelDatosLaborales from "./components/PanelDatosLaborales";
import PanelImpuestos from "./components/PanelImpuestos";
import PanelVeraz from "./components/PanelVeraz";
import PanelVinculos from "./components/PanelVinculos";
import PanelBoletinOficial from "../../../../components/panel-boletin-oficial/PanelBoletinOficial";
import PanelBienesPersonales from "./components/PanelBienesPersonales";
import PanelContactacion from "../../../../components/panel-contactacion/PanelContactacion";
import PanelSituacionFinanciera from "../../../../components/panel-situacion-financiera/PanelSituacionFinanciera";
import PanelNodoFederal from "./components/PanelNodoFederal";
import Navegador from "./components/navegador/Navegador";
import StatusDialog from "../../../..//components/status-dialog/StatusDialog";
import RequestInfoDialog from "../../../../components/request-info-dialog/RequestInfoDialog";
import CrearPDF, { CrearPDFTIPODIALOGO } from "./components/pdf/CrearPDF";
import Card from "../../../../components/card/Card";
import Restringido from "../../../dashboard/components/restringido/Restringido";

class PersonasDetalle extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			statusDialogShow: false,
			restringido: false,
			mensaje_restringido: "",
			requestInfoDialog: {
				show: false,
				blockName: "",
				subBlockName: "",
			},
			showPanels: {
				panelVeraz: null,
				panelDatosParticulares: null,
				panelDatosLaborales: null,
				panelImpuestos: null,
				panelVinculos: null,
				panelParticipacionSocietaria: null,
				panelBoletinOficial: null,
				panelContactacion: null,
				panelBienesPersonales: null,
				panelSituacionFinanciera: null,
			},
			info: {
				datosParticulares: {
					cuil: this.props.cuil,
				},
			},
			consultasPorRubro: {
				totalConsultas: 0,
			},
			hidePanels: [],
			fecha: moment(),
			mostrarPDF: false,
			rangoIngresos: {},
			enablePrint: false,
		};
	}

	componentDidMount() {
		UI.showProgress(true);
		ApiClient.getRangoIngresos().then((data) => {
			this.setState({
				rangoIngresos: data.reduce((acc, item) => {
					acc[item.nombre] = item.rango;
					return acc;
				}, {}),
			});
		});
		ApiClient.getPerson(this.props.cuil)
			.then(this.onFinishGetPerson)
			.catch(function (error) {
				UI.showProgress(false);
				UI.showError(error);
			});
		ApiClient.getConsultasPorRubro(this.props.cuil).then(
			this.onFinishGetConsultasPorRubro
		);
		ApiClient.getFeatureFlag(FF_PRINT_PDF).then((res) => {
			this.setState({
				enablePrint: res.results.AGD__ALLOW_PRINT_PDF,
			})
		})
		// TODO: revisar qué pasa si el servicio devuelve error (no queremos que se cierre la sesión con error inesperado)
	}

	onFinishGetPerson = (res) => {
		UI.showProgress(false);
		if (res.result.code === 200) {
			if (res.data) {
				this.procesarInfo(res.data);
			} else {
				throw UI.handledError("No se encontraron resultados");
			}
		} else if (res.result.code === 405) {
			this.setState({
				restringido: true,
				mensaje_restringido: res.result.info,
			});
		} else {
			throw UI.handledError(res.result.info);
		}
	};

	onFinishGetConsultasPorRubro = (res) => {
		if (res) {
			this.setState({
				consultasPorRubro: res,
			});
		}
	};

	procesarInfo = (info) => {
		let hidePanels = this.hideSubPanels(info);
		let showPanels = this.mostrarPaneles(info);
		let newInfo = merge(this.state.info, info);
		this.setState({
			info: newInfo,
			showPanels: showPanels,
			hidePanels: hidePanels,
		});
	};

	/**
	 *
	 * @param {*} info
	 * @returns
	 */
	mostrarPaneles = (info) => {
		let showPanels = {
			panelVeraz: false,
			panelDatosParticulares: true,
			panelDatosLaborales: null,
			panelImpuestos: null,
			panelVinculos: null,
			panelParticipacionSocietaria: null,
			panelBoletinOficial: null,
			panelContactacion: null,
			panelBienesPersonales: null,
			panelSituacionFinanciera: null,
		};

		if (info.veraz) {
			showPanels.panelVeraz = true;
		}

		if (
			info.datosLaborales &&
			(info.datosLaborales.datoLaboral ||
				info.datosLaborales.datoLaboral === null ||
				info.datosLaborales.monotributista ||
				info.datosLaborales.monotributista === null ||
				info.datosLaborales.aportesAM ||
				info.datosLaborales.aportesAM === null ||
				info.datosLaborales.actividad ||
				info.datosLaborales.actividad === null ||
				info.datosLaborales.obraSocial ||
				info.datosLaborales.obraSocial === null ||
				info.datosLaborales.empAportes ||
				info.datosLaborales.empAportes === null ||
				info.datosLaborales.sueldos ||
				info.datosLaborales.sueldos === null ||
				info.datosLaborales.empDomesticos ||
				info.datosLaborales.empDomesticos === null ||
				info.datosLaborales.domEmpleadores ||
				info.datosLaborales.domEmpleadores === null ||
				info.datosLaborales.domAportes ||
				info.datosLaborales.domAportes === null ||
				info.datosLaborales.seguridadSocial ||
				info.datosLaborales.seguridadSocial === null ||
				info.datosLaborales.jubilacion ||
				info.datosLaborales.jubilacion === null)
		) {
			showPanels.panelDatosLaborales = true;
		}

		if (info.pagosImpuestos || info.pagosImpuestos === null) {
			showPanels.panelImpuestos = true;
		}

		if (
			info.vinculos &&
			(info.vinculos.vinculos ||
				info.vinculos.otrosVinculos ||
				info.vinculos.vinculos === null ||
				info.vinculos.otrosVinculos === null)
		) {
			showPanels.panelVinculos = true;
		}

		if (
			info.participacionSocietaria ||
			info.participacionSocietaria === null
		) {
			showPanels.panelParticipacionSocietaria = true;
		}

		if (
			info.boletinOficial ||
			info.boletinOficial === null ||
			(info.morosidad &&
				(info.morosidad.embargos ||
					info.morosidad.embargos === null ||
					info.morosidad.juiciosDemandado ||
					info.morosidad.juiciosDemandado === null ||
					info.morosidad.juicioActor ||
					info.morosidad.juicioActor === null))
		) {
			showPanels.panelBoletinOficial = true;
		}

		if (
			info.telefonos ||
			info.telefonos === null ||
			info.telefonosAdicionales ||
			info.telefonosAdicionales === null ||
			info.telefonosCelulares ||
			info.telefonosCelulares === null ||
			info.datosParticulares.mails ||
			info.datosParticulares.mails === null
		) {
			showPanels.panelContactacion = true;
		}

		if (
			info.bienesPersonales &&
			(info.bienesPersonales.propiedades ||
				info.bienesPersonales.automotores ||
				info.bienesPersonales.propiedades === null ||
				info.bienesPersonales.automotores === null)
		) {
			showPanels.panelBienesPersonales = true;
		}

		if (
			(info.situacionFinanciera &&
				(info.situacionFinanciera.bancoOpera ||
					info.situacionFinanciera.bancoOpera === null)) ||
			(info.morosidad &&
				(info.morosidad.informacionBcra ||
					info.morosidad.informacionBcra === null ||
					info.morosidad.chequesRechazados ||
					info.morosidad.chequesRechazados === null ||
					info.morosidad.deudoresBancoCentral ||
					info.morosidad.deudoresBancoCentral === null ||
					info.morosidad.deudoresCentroComercial ||
					info.morosidad.deudoresCentroComercial === null))
		) {
			showPanels.panelSituacionFinanciera = true;
		}

		return showPanels;
	};

	/**
	 *
	 * @param {*} info
	 * @returns
	 */
	hideSubPanels = (info) => {
		let result = [];

		// Compruebo Veraz
		if (info.veraz) {
			// Si la respuesta incluye el token para el Call to Action, debo ocultar el subbloque
			if (info.veraz.tokenCA != null) {
				result.push(INFO_KEY.veraz);
			}
		}

		if (info.datosParticulares) {
			if (info.datosParticulares.domAlternativos === undefined) {
				result.push(INFO_KEY.domAlternativos);
				info.datosParticulares.domAlternativos = undefined;
			}
			if (info.datosParticulares.mails === undefined) {
				result.push(INFO_KEY.mails);
				info.datosParticulares.mails = undefined;
			}
		}

		if (info.telefonos === undefined) {
			result.push(INFO_KEY.telefonos);
			info.telefonos = undefined;
		}
		if (info.telefonosCelulares === undefined) {
			result.push(INFO_KEY.telefonosCelulares);
			info.telefonosCelulares = undefined;
		}
		if (info.telefonosAdicionales === undefined) {
			result.push(INFO_KEY.telefonosAdicionales);
			info.telefonosAdicionales = undefined;
		}

		if (info.datosLaborales) {
			if (info.datosLaborales.datoLaboral === undefined) {
				result.push(INFO_KEY.datoLaboral);
				info.datosLaborales.datoLaboral = undefined;
			}
			if (info.datosLaborales.monotributista === undefined) {
				result.push(INFO_KEY.monotributista);
				info.datosLaborales.monotributista = undefined;
			}
			if (info.datosLaborales.aportesAM === undefined) {
				result.push(INFO_KEY.aportesAM);
				info.datosLaborales.aportesAM = undefined;
			}
			if (info.datosLaborales.actividad === undefined) {
				result.push(INFO_KEY.actividad);
				info.datosLaborales.actividad = undefined;
			}
			if (info.datosLaborales.obraSocial === undefined) {
				result.push(INFO_KEY.obraSocial);
				info.datosLaborales.obraSocial = undefined;
			}
			if (info.datosLaborales.empAportes === undefined) {
				result.push(INFO_KEY.empAportes);
				info.datosLaborales.empAportes = undefined;
			}
			if (info.datosLaborales.sueldos === undefined) {
				result.push(INFO_KEY.sueldosCobrados);
				info.datosLaborales.sueldos = undefined;
			}
			if (info.datosLaborales.empDomesticos === undefined) {
				result.push(INFO_KEY.empDomesticos);
				info.datosLaborales.empDomesticos = undefined;
			}
			if (info.datosLaborales.domEmpleadores === undefined) {
				result.push(INFO_KEY.domEmpleadores);
				info.datosLaborales.domEmpleadores = undefined;
			}
			if (info.datosLaborales.domAportes === undefined) {
				result.push(INFO_KEY.domAportes);
				info.datosLaborales.domAportes = undefined;
			}
			if (info.datosLaborales.seguridadSocial === undefined) {
				result.push(INFO_KEY.seguridadSocial);
				info.datosLaborales.seguridadSocial = undefined;
			}
			if (info.datosLaborales.jubilacion === undefined) {
				result.push(INFO_KEY.jubilacion);
				info.datosLaborales.jubilacion = undefined;
			}
		}

		if (info.pagosImpuestos === undefined) {
			result.push(INFO_KEY.pagosImpuestos);
			info.pagosImpuestos = undefined;
		}

		if (info.boletinOficial === undefined) {
			result.push(INFO_KEY.parteSociedad);
			info.boletinOficial = undefined;
		}

		if (info.participacionSocietaria === undefined) {
			result.push(INFO_KEY.participacionSocietaria);
			info.participacionSocietaria = undefined;
		}

		if (info.vinculos) {
			if (info.vinculos.vinculos === undefined) {
				result.push(INFO_KEY.vinculos);
				info.vinculos.vinculos = undefined;
			}
			if (info.vinculos.otrosVinculos === undefined) {
				result.push(INFO_KEY.otrosVinculos);
				info.vinculos.otrosVinculos = undefined;
			}
		}

		if (info.bienesPersonales) {
			if (info.bienesPersonales.propiedades === undefined) {
				result.push(INFO_KEY.propiedades);
				info.bienesPersonales.propiedades = undefined;
			}
			if (info.bienesPersonales.automotores === undefined) {
				result.push(INFO_KEY.automotores);
				info.bienesPersonales.automotores = undefined;
			}
		}

		if (info.situacionFinanciera) {
			if (info.situacionFinanciera.bancoOpera === undefined) {
				result.push(INFO_KEY.bancoOpera);
				info.situacionFinanciera.bancoOpera = undefined;
			}
		}

		if (info.morosidad) {
			if (info.morosidad.informacionBcra === undefined) {
				result.push(INFO_KEY.informacionBcra);
				info.morosidad.informacionBcra = undefined;
			}
			if (info.morosidad.chequesRechazados === undefined) {
				result.push(INFO_KEY.chequesRechazados);
				info.morosidad.chequesRechazados = undefined;
			}
			if (info.morosidad.deudoresBancoCentral === undefined) {
				result.push(INFO_KEY.deudoresBancoCentral);
				info.morosidad.deudoresBancoCentral = undefined;
			}
			if (info.morosidad.deudoresCentroComercial === undefined) {
				result.push(INFO_KEY.deudoresCentroComercial);
				info.morosidad.deudoresCentroComercial = undefined;
			}
			if (info.morosidad.embargos === undefined) {
				result.push(INFO_KEY.embargos);
				info.morosidad.embargos = undefined;
			}
			if (info.morosidad.juiciosDemandado === undefined) {
				result.push(INFO_KEY.juiciosDemandado);
				info.morosidad.juiciosDemandado = undefined;
			}
			if (info.morosidad.juicioActor === undefined) {
				result.push(INFO_KEY.juiciosActor);
				info.morosidad.juicioActor = undefined;
			}
		}

		return result;
	};

	onRequestInfo = (blockName, subBlockName) => {
		this.setState({
			requestInfoDialog: {
				show: true,
				blockName: blockName,
				subBlockName: subBlockName,
				onResultRequestInfo: this.onResultRequestInfo,
			},
		});
	};

	onResultRequestInfo = (result) => {
		this.setState({
			requestInfoDialog: {
				show: false,
			},
		});

		if (result === false) return;

		UI.showProgress(true);
		ApiClient.requestExtraInfo(
			this.state.info.idLog,
			this.state.requestInfoDialog.blockName,
			this.state.requestInfoDialog.subBlockName
		)
			.then(function (res) {
				UI.showProgress(false);
				if (res.result.code === 200) {
					UI.showAlert(lstrings.solicitar_informacion_ok);
				} else {
					throw UI.handledError(res.result.info);
				}
			})
			.catch(function (error) {
				UI.showProgress(false);
				UI.showError(error);
			});
	};

	onRequestVerazInfo = (blockName, subBlockName) => {
		let body = (
			<div>
				<h4>Elija aceptar para acceder a los siguientes datos:</h4>
				<ul>
					<li>Score Veraz de riesgo crediticio.</li>
					<li>Predictor Veraz de Ingresos.</li>
					<li>Observaciones de morosidad.</li>
				</ul>
				<strong className="text-center" style={{ color: "red" }}>
					La solicitud de esta información implica un costo adicional.
				</strong>
			</div>
		);

		this.setState({
			requestInfoDialog: {
				show: true,
				blockName: blockName,
				subBlockName: subBlockName,
				onResultRequestInfo: this.onResultRequestVerazInfo,
				bodyVeraz: body,
			},
		});
	};

	/**
	 * Actualizo la explicación del score para mostrar en el PDF
	 *
	 * @param {string} explanation
	 */
	updateVerazScoreExplanationPdf = (explanation) => {
		this.setState({
			...this.state,
			info: {
				...this.state.info,
				veraz: {
					...this.state.info.veraz,
					scoreExplanation: explanation,
				},
			},
		});
	};

	onResultRequestVerazInfo = (result) => {
		this.setState({
			requestInfoDialog: {
				show: false,
				bodyVeraz: undefined,
			},
		});

		if (result === false) return;

		UI.showProgress(true);
		ApiClient.getInformeVeraz(this.state.info.veraz.tokenCA)
			.then(this.procesarResultRequestVerazInfo)
			.catch(function (error) {
				UI.showProgress(false);
				UI.showError(error);
			});
	};

	procesarResultRequestVerazInfo = (response) => {
		UI.showProgress(false);
		if (response.result.code === 200) {
			this.setState({
				...this.state,
				info: {
					...this.state.info,
					veraz: response.data,
				},
			});

			let hidePanels = this.hideSubPanels(this.state.info);
			let showPanels = this.mostrarPaneles(this.state.info);
			this.setState({
				...this.state,
				showPanels: showPanels,
				hidePanels: hidePanels,
			});
		} else {
			throw UI.handledError(response.result.info);
		}
	};

	onStatusDialogShow = () => {
		this.setState({
			statusDialogShow: true,
		});
	};

	onStatusDialogClose = () => {
		this.setState({
			statusDialogShow: false,
		});
	};

	onPDF = () => {
		this.setState({
			mostrarPDF: true,
			tipodialogo: CrearPDFTIPODIALOGO.descargar,
		});
	};

	onPrint = () => {
		this.setState({
			mostrarPDF: true,
			tipodialogo: CrearPDFTIPODIALOGO.imprimir,
		});
	};

	cerrarPDF = () => {
		this.setState({
			mostrarPDF: false,
		});
	};

	render() {
		const restringido = <Restringido message={this.state.mensaje_restringido}/>

		const resultado = (
			<div>
				<Card infoCredito={this.state.info.credito} />
				<Navegador
					showPanels={this.state.showPanels}
					onPDF={this.onPDF}
					pdfEnable={this.state.enablePrint}
				/>

				{this.state.statusDialogShow && (
					<StatusDialog
						show={this.state.statusDialogShow}
						onClose={this.onStatusDialogClose}
						idLog={this.state.info.idLog}
						nombre={
							this.state.info.datosParticulares.apellidoNombre
						}
						cuil={this.state.info.datosParticulares.cuil}
						status={this.state.info.codigo}
						variables={VARIABLES_PERSONAS}
						validacion={this.state.info.variables}
						fecha={this.state.fecha}
					/>
				)}

				<RequestInfoDialog
					show={this.state.requestInfoDialog.show}
					blockName={this.state.requestInfoDialog.blockName}
					subBlockName={this.state.requestInfoDialog.subBlockName}
					onResult={this.state.requestInfoDialog.onResultRequestInfo}
					body={this.state.requestInfoDialog.bodyVeraz}
				/>

				<div className="resultado-busqueda -detalle">
					{this.state.info.datosParticulares.dni && (
						<HeaderDetalle
							nombre={
								this.state.info.datosParticulares.apellidoNombre
							}
							cuil={this.state.info.datosParticulares.cuil}
							datosParticulares={
								this.state.info.datosParticulares
							}
							consultasPorRubro={this.state.consultasPorRubro}
							status={this.state.info.codigo}
							onStatusDialogShow={this.onStatusDialogShow}
							onPrint={this.onPrint}
							enablePrint={this.state.enablePrint}
						/>
					)}
					{this.state.showPanels.panelVeraz && (
						<PanelVeraz
							info={this.state.info.veraz}
							onRequestInfo={this.onRequestVerazInfo}
							onRetry={this.onResultRequestVerazInfo}
							hidePanels={this.state.hidePanels}
							updateScoreExplanationPdf={
								this.updateVerazScoreExplanationPdf
							}
						/>
					)}
					{process.env.REACT_APP_FLAVOR === "reseller" &&
						this.state.showPanels.panelSituacionFinanciera && (
							<PanelNodoFederal
								deudoresCentro={
									this.state.info.morosidad
										.deudoresCentroComercial
								}
								onRequestInfo={this.onRequestInfo}
								hidePanels={this.state.hidePanels}
							/>
						)}
					{this.state.showPanels.panelDatosParticulares && (
						<PanelDatosParticulares
							info={this.state.info.datosParticulares}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					)}
					{this.state.showPanels.panelContactacion && (
						<PanelContactacion
							telefonos={this.state.info.telefonos}
							telefonosCelulares={
								this.state.info.telefonosCelulares
							}
							telefonosAdicionales={
								this.state.info.telefonosAdicionales
							}
							mails={this.state.info.datosParticulares.mails}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					)}
					{this.state.showPanels.panelDatosLaborales && (
						<PanelDatosLaborales
							cuil={this.props.cuil}
							info={this.state.info.datosLaborales}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
							rangoIngresos={this.state.rangoIngresos}
						/>
					)}
					{this.state.showPanels.panelImpuestos &&
						this.state.info.pagosImpuestos && (
							<PanelImpuestos
								info={this.state.info.pagosImpuestos}
								onRequestInfo={this.onRequestInfo}
								hidePanels={this.state.hidePanels}
							/>
						)}
					{this.state.showPanels.panelVinculos && (
						<PanelVinculos
							info={this.state.info.vinculos}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					)}
					{this.state.showPanels.panelBienesPersonales && (
						<PanelBienesPersonales
							info={this.state.info.bienesPersonales}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					)}
					{this.state.showPanels.panelSituacionFinanciera && (
						<PanelSituacionFinanciera
							info={this.state.info.situacionFinanciera}
							morosidad={this.state.info.morosidad}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					)}
					{this.state.showPanels.panelBoletinOficial && (
						<PanelBoletinOficial
							participacionSocietaria={
								this.state.info.participacionSocietaria
							}
							boletinOficial={this.state.info.boletinOficial}
							embargos={this.state.info.morosidad.embargos}
							juiciosActor={this.state.info.morosidad.juicioActor}
							juiciosDemandado={
								this.state.info.morosidad.juiciosDemandado
							}
							onRequestInfo={this.onRequestInfo}
							hidePanels={this.state.hidePanels}
						/>
					)}
				</div>

				<CrearPDF
					mostrarPDF={this.state.mostrarPDF}
					onCerrarPDF={this.cerrarPDF}
					info={this.state.info}
					consultasPorRubro={this.state.consultasPorRubro}
					fecha={this.state.fecha}
					tipodialogo={this.state.tipodialogo}
					showPanels={this.state.showPanels}
				/>
			</div>
		);

		const vista = this.state.restringido ? restringido : resultado;

		return <div>{vista}</div>;
	}
}

PersonasDetalle.propTypes = {
	cuil: PropTypes.string,
};

export default PersonasDetalle;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/PersonasDetalle.js